export default {
    namespaced: true,

    state: {
        invoices: null,
    },

    getters: {
        hasInvoices: (state) => {
            return (state.invoices && state.invoices.Rows && state.invoices.Rows.length);
        },
    },

    actions: {
        getInvoices({ commit }, params) {
            commit('setTransactions', null);

            return axios.get('/api/contacts/invoices', {
                params: params,
            })
            .then((response) => {
                commit('setTransactions', response.data.data);
            })
            .catch(() => {
                commit('setTransactions', []);
            });
        },
    },

    mutations: {
        setTransactions(state, invoices) {
            state.invoices = invoices;
        },
    },
};
